module.exports = __webpack_public_path__ + "img/1438598353.0fa5ddec.jpg";